
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../../contexts/CartContext';
import CartPanel from '../../../components/CartPanel';

const product = {
  id: 1,
  name: 'Rides & Dives Classic Hoodie',
  price: 59.99,
  sizes: ['XS', 'S', 'M', 'L', 'XL', '2XL'],
  description: 'Premium heavyweight hoodie with embroidered logo. Perfect for cold morning rides.',
  longDescription:
    'Our signature Classic Hoodie is built for riders who demand both style and substance. Crafted from premium heavyweight cotton blend fabric, this hoodie features our iconic Rides & Dives logo embroidered on the chest. The relaxed fit allows for comfortable layering over riding gear, while the kangaroo pocket keeps your hands warm during those early morning starts. Double-stitched seams ensure durability mile after mile.',
  features: [
    '80% cotton, 20% polyester heavyweight blend',
    'Embroidered logo on chest',
    'Kangaroo pocket',
    'Ribbed cuffs and hem',
    'Double-stitched seams',
    'Relaxed fit for layering',
  ],
  image: 'https://static.readdy.ai/image/53a123dbe8c72020ea380fa944f94eac/7a9603ccf45559a5ef82ce4889be98a2.png',
  gallery: [
    'https://static.readdy.ai/image/53a123dbe8c72020ea380fa944f94eac/7a9603ccf45559a5ef82ce4889be98a2.png',
  ],
};

export default function ClassicHoodiePage() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedSize, setSelectedSize] = useState<string>('');
  const [cartOpen, setCartOpen] = useState(false);
  const [activeImage, setActiveImage] = useState(0);

  const { addItem, totalItems } = useCart();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAddToCart = () => {
    if (!selectedSize) {
      alert('Please select a size');
      return;
    }

    addItem({
      id: product.id,
      name: product.name,
      price: product.price,
      size: selectedSize,
      image: product.image,
    });

    setCartOpen(true);
  };

  return (
    <div className="bg-black text-white min-h-screen">
      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-black' : 'bg-black/90'
        }`}
      >
        <div className="flex items-center justify-between h-20 md:h-24 px-4 md:px-8">
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/53a123dbe8c72020ea380fa944f94eac/1d9414342dd58a00fdde5ee22dbe4d3e.png"
              alt="Rides & Dives Logo"
              className="h-16 md:h-20 w-auto"
            />
          </Link>

          <div className="flex items-center gap-4">
            <button
              onClick={() => setCartOpen(true)}
              className="relative text-white hover:text-[#8B6F47] transition-colors cursor-pointer"
            >
              <i className="ri-shopping-cart-line text-2xl"></i>
              {totalItems > 0 && (
                <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center bg-[#8B6F47] text-black text-xs font-bold rounded-full">
                  {totalItems}
                </span>
              )}
            </button>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden text-white text-2xl cursor-pointer"
            >
              <i className={mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>

          <div className="hidden lg:flex items-center gap-8 xl:gap-12">
            <Link
              to="/rides"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              Rides
            </Link>
            <Link
              to="/dives"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              Dives
            </Link>
            <Link
              to="/gear"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              Gear
            </Link>
            <Link
              to="/gallery"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              Gallery
            </Link>
            <Link
              to="/merch"
              className="text-sm font-light tracking-widest uppercase text-[#8B6F47] cursor-pointer whitespace-nowrap"
            >
              Merch
            </Link>
            <Link
              to="/trip-planner"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              Plan
            </Link>
            <Link
              to="/about"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </Link>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden bg-black border-t border-white/10">
            <div className="flex flex-col py-4 px-4 space-y-4">
              <Link
                to="/rides"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                Rides
              </Link>
              <Link
                to="/dives"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                Dives
              </Link>
              <Link
                to="/gear"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                Gear
              </Link>
              <Link
                to="/gallery"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                Gallery
              </Link>
              <Link
                to="/merch"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase text-[#8B6F47] cursor-pointer py-2"
              >
                Merch
              </Link>
              <Link
                to="/trip-planner"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                Plan
              </Link>
              <Link
                to="/about"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                About
              </Link>
              <Link
                to="/contact"
                onClick={() => setMobileMenuOpen(false)}
                className="text-sm font-light tracking-widest uppercase hover:text-[#8B6F47] transition-colors cursor-pointer py-2"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>

      {/* Breadcrumb */}
      <div className="pt-24 md:pt-28 px-4 md:px-16 bg-black">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-white/60">
            <Link to="/" className="hover:text-[#8B6F47] transition-colors cursor-pointer">
              Home
            </Link>
            <span>/</span>
            <Link to="/merch" className="hover:text-[#8B6F47] transition-colors cursor-pointer">
              Merch
            </Link>
            <span>/</span>
            <span className="text-white">{product.name}</span>
          </nav>
        </div>
      </div>

      {/* Product Detail */}
      <section className="py-12 md:py-20 px-4 md:px-16 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            {/* Product Images */}
            <div>
              <div className="relative aspect-square bg-[#1A1A1A] mb-4 overflow-hidden">
                <img
                  src={product.gallery[activeImage]}
                  alt={product.name}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              {product.gallery.length > 1 && (
                <div className="grid grid-cols-4 gap-2">
                  {product.gallery.map((img, idx) => (
                    <button
                      key={idx}
                      onClick={() => setActiveImage(idx)}
                      className={`aspect-square bg-[#1A1A1A] overflow-hidden cursor-pointer ${
                        activeImage === idx ? 'ring-2 ring-[#8B6F47]' : ''
                      }`}
                    >
                      <img src={img} alt="" className="w-full h-full object-cover" />
                    </button>
                  ))}
                </div>
              )}
            </div>

            {/* Product Info */}
            <div>
              <h1 className="text-3xl md:text-5xl font-bold mb-4">{product.name}</h1>
              <p className="text-[#8B6F47] text-3xl font-bold mb-6">${product.price}</p>

              <p className="text-white/70 text-lg leading-relaxed mb-8">{product.longDescription}</p>

              {/* Size Selection */}
              <div className="mb-8">
                <label className="text-white text-sm uppercase tracking-wider mb-4 block">
                  Select Size <span className="text-[#8B6F47]">*</span>
                </label>
                <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
                  {product.sizes.map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(size)}
                      className={`px-4 py-3 text-sm uppercase tracking-wider transition-all cursor-pointer ${
                        selectedSize === size
                          ? 'bg-[#8B6F47] text-black font-medium'
                          : 'bg-white/5 text-white/70 hover:bg-white/10'
                      }`}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>

              {/* Add to Cart */}
              <button
                onClick={handleAddToCart}
                className="w-full px-8 py-4 bg-[#8B6F47] text-black text-sm uppercase tracking-wider hover:bg-[#A08558] transition-colors cursor-pointer whitespace-nowrap font-medium mb-8"
              >
                Add to Cart
              </button>

              {/* Features */}
              <div className="border-t border-white/10 pt-8">
                <h3 className="text-lg font-bold mb-4">Features</h3>
                <ul className="space-y-3">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3 text-white/70">
                      <i className="ri-check-line text-[#8B6F47] mt-0.5"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Back to Merch */}
      <section className="py-12 px-4 md:px-16 bg-[#111]">
        <div className="max-w-7xl mx-auto text-center">
          <Link
            to="/merch"
            className="inline-flex items-center gap-2 text-[#8B6F47] hover:text-[#A08558] transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            Back to All Merch
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A0A0A] pt-12 md:pt-20 pb-8">
        <div className="px-4 md:px-16">
          <div className="border-t border-[#8B6F47]/30 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/50 text-sm text-center md:text-left">
              © 2025 Rides & Dives. 120,000 miles and counting.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">
                Privacy
              </Link>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="nofollow"
                className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      <CartPanel isOpen={cartOpen} onClose={() => setCartOpen(false)} />
    </div>
  );
}
